import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { CodeTypeModel }        from '../../app-lite/core/models/code-type';
import { PriceMatrixComponent } from '../../app-lite/price-matrix/price-matrix.settings.component';
import { PriceMatrixModel }     from '../../app-lite/price-matrix/typings/price-matrix.matrix';
import { PriceMatrixService }   from '../../app-lite/price-matrix/price-matrix.service';

export const PriceMatrixStates : Array<NgHybridStateDeclaration> = [
  {
    component: PriceMatrixComponent,
    name     : 'app.price-matrix',
    resolve  : [
      {
        deps     : [ PriceMatrixService ],
        resolveFn: ( priceMatrixService : PriceMatrixService ) : Promise<Array<PriceMatrixModel>> => priceMatrixService.get(),
        token    : 'matrices'
      },
      {
        deps     : [ PriceMatrixService ],
        resolveFn: ( priceMatrixService : PriceMatrixService ) : Promise<Array<CodeTypeModel>> => priceMatrixService.getTypes(),
        token    : 'types'
      },
      {
        deps     : [ PriceMatrixService ],
        resolveFn: ( priceMatrixService : PriceMatrixService ) : Promise<Array<CodeTypeModel>> => priceMatrixService.getUpdateTypes(),
        token    : 'updateTypes'
      }
    ],
    url: '/price-matrix'
  }
];
